module.exports = __webpack_public_path__ + "img/left.b9a69b60.svg";